import React from 'react';
import {
    RiHtml5Fill,
    RiCss3Fill,
    RiReactjsLine,
  } from 'react-icons/ri';
  import { DiJavascript1 } from 'react-icons/di';
  import { FaFigma } from 'react-icons/fa6';
  import { FaPhp } from 'react-icons/fa';
  
  const SkillProgress = () => {
    const skills = [
      {
        icon: <RiHtml5Fill size='50' />,
        name: 'HTML',
        progress: 98,
      },
      {
        icon: <RiCss3Fill size='50' />,
        name: 'CSS',
        progress: 96,
          },
      {
        icon: <DiJavascript1 size='50' />,
        name: 'JavaScript',
        progress: 95,
      },
      {
        icon: <RiReactjsLine size='50' />,
        name: 'React JS',
        progress: 90,
      },
      {
        icon: <FaPhp size='50' />,
        name: 'PHP',
        progress: 90,
      },
      {
        icon: <FaFigma size='50' />,
        name: 'Figma',
        progress: 95,
      },
    ];
  
    return (
      <div className='flex flex-wrap justify-center items-center md:gap-x-5 gap-x-20 lg:gap-x-10 pt-32 lg:pl-32 lg:w-10/12'>
        {skills.map((skill, index) => (
          <div key={index} className='text-center hover:shadow-lg transform hover:scale-105 transition duration-300 ease-in-out'>
            <div className='w-24 h-24 rounded-full bg-orange-default bg-opacity-30 flex justify-center items-center'>
              {skill.icon}
            </div>
            <h3 className='text-white font-bold text-xl mt-4'>{skill.name}</h3>
            <div className='w-24 h-2 bg-gray-700 rounded mt-2'>
              <div
                className='h-2 bg-orange-default'
                style={{ width: `${skill.progress}%` }}
              ></div>
            </div>
            <p className='text-white font-medium mt-2'>
              Progress: {skill.progress}%
            </p>
          </div>
        ))}
      </div>
    );
  };
  
  export default SkillProgress;
  